import React, { useEffect, useState } from "react";
import Styles from "./CurrentGoldPrice.module.css";
import { useNavigate } from "react-router-dom";
import { getCurrentGoldPriceAction } from "../../../../store/actions/dashboard/DashboardActions";
import ShimmerLoader from "../../../pages/ShimmerLoader/ShimmerLoader";
import currenyFormat from "../../common/currentFormat";
import Amount from "./Amount";

const CurrentGoldPrice = () => {
  const navigate = useNavigate();
  const [goldPrice, setGoldPrice] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // const fetchGoldPrice = async () => {
    //   try {
    //     setLoading(true);
    //     const result = await getCurrentGoldPriceAction();
    //     setGoldPrice(result.data);
    //     setLoading(false);
    //   } catch (error) {
    //     setLoading(false);
    //     console.error("Failed to fetch gold price:", error);
    //   }
    // };
    // fetchGoldPrice();
    // const intervalId = setInterval(fetchGoldPrice, 1000);
    // return () => clearInterval(intervalId);
  }, []);

  const formatPrice = (value) => {
    // debugger;
    const numericValue = Number(value);

    // Check if the conversion is valid
    if (isNaN(numericValue)) return "NA";

    // Convert to a fixed number with two decimal places
    const fixedValue = numericValue.toFixed(2);
    const [integerPart, decimalPart] = fixedValue.split(".");

    // Add comma as thousand separators
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Return formatted string
    return `${formattedInteger}.${decimalPart}`;
  };

  if (!loading) {
    return (
      <div className={`${Styles.price_container} card-body d-flex justify-content-between align-items-center`}>
        <p className={`${Styles.price_title}`}>
          Current Gold Price
          <span className={`${Styles.gram}`}> (gm)</span>
        </p>
        <div className={`d-flex justify-content-center`}>
          {/* <p className={`${Styles.price} text-primary`}>{goldPrice.totalAmount ? goldPrice.totalAmount : "NA"}</p> */}
          {/* <p className={`${Styles.price} text-primary`}> ₹ {goldPrice.totalAmount ? formatPrice(goldPrice.totalAmount) : "NA"}</p> */}
          <p className={`${Styles.price} text-primary`}><Amount /></p>
          <div className='d-flex flex-column justify-content-between'>
            <p className={`${Styles.currency} ${Styles.blink_me} text-primary`}>
              <span className={Styles.dot}></span>LIVE
            </p>
            {/* <p className={`${Styles.currency} text-primary`}>INR</p> */}
          </div>
        </div>
      </div>
    );
  }
};

export default CurrentGoldPrice;
